import { UnformattedFptiOptions } from '@/types'
import { stringifyFptiProps } from '@/utils'

export const commonProperties: UnformattedFptiOptions = {
  pageGroup: 'preview_business_profile',
  pageName: 'preview_page',
}

export const PREVIEW_PROFILE_SCREEN_SHOWN_FPTI = {
  ...commonProperties,
  eventName: 'bp_seller_profile_preview_shown',
}

export const PREVIEW_PROFILE_BACK_LINK_CLICK_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'bp_seller_profile_preview_back_click',
})

export const PREVIEW_PROFILE_EDIT_BUTTON_CLICK_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'bp_seller_profile_preview_edit_click',
})

export const PREVIEW_PROFILE_SHARE_BUTTON_CLICK_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'bp_seller_profile_preview_share_click',
})
